const CheckmarkIcon = ({ width = 24, height = 24, color = '#E43C5F', className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    className={className}
    style={{ minWidth: width, minHeight: height, flexShrink: 0, display: 'block' }}
  >
    <path
      d="M9.09091 15.6364L5.90909 12.4545C5.55764 12.1031 4.98782 12.1031 4.63636 12.4545C4.28491 12.806 4.28491 13.3758 4.63636 13.7273L9.09091 18.1818L19.3636 7.90909C19.7151 7.55764 19.7151 6.98782 19.3636 6.63636C19.0122 6.28491 18.4424 6.28491 18.0909 6.63636L9.09091 15.6364Z"
      fill={color}
    />
  </svg>
);

export default CheckmarkIcon;
